<!--
  @component
  Generates an SVG x-axis. This component is also configured to detect if your x-scale is an ordinal scale. If so, it will place the markers in the middle of the bandwidth.
 -->
 <script>
  import { getContext } from 'svelte';
  import AxisX from './AxisX.svelte';
  import AxisY from './AxisY.svelte';
  import { timeParse, timeFormat } from "d3-time-format";



  const { width, height, xScale, yRange, xDomain } = getContext('LayerCake');

  export let dataValue;
  export let yTicks;
  export let allYTicks;

  let xTicks = []
  $: {
    xTicks = [];
    for (let year = $xDomain[0].getFullYear(); year <= $xDomain[1].getFullYear(); year++) {
      xTicks.push(new Date(year.toString()))
    }
  }

  const formatTickX = timeFormat("%Y");
	$: shouldAddSuffix = (d) => dataValue !== 'count' && d === yTicks[yTicks.length - 1];


</script>

{#if $width > 100}
  <AxisX formatTick={formatTickX} {xTicks} {yTicks} />
  <AxisY {shouldAddSuffix} {allYTicks} {xTicks} {yTicks} />
{/if}